module.exports = __webpack_public_path__ + "img/Screenshot_6.c54ed3c8.png";